import React, { useState } from 'react';

import Icon from 'components/DesignSystem/Icon';
import { IconType } from 'components/DesignSystem/Icon/icons';
import { useClosure } from 'utils/hooks';
import useLeftCollapse from 'utils/hooks/sidebars/useLeftCollapse';
import { useSelector } from 'react-redux';
import { selectUserIsAdmin } from 'redux/reducers/authReducer';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import logout from 'utils/logout';
import versionString from 'helper/version';
import featureFlags from 'constants/featureFlags';
import SimpleOption from './Options/SimpleOption';
import ExpandableOption from './Options/ExpandableOption';

import './index.scss';

export default function Sidebar() {
  const [expandedOption, setExpandedOption] = useState('');
  const [collapsed, setCollapsed] = useLeftCollapse();
  const collapseIcon: IconType = collapsed ? 'right_arrow' : 'left_arrow';
  const admin = useSelector(selectUserIsAdmin);
  const navigate = useNavigate();

  return (
    <div className="new-sidebar-container">
      <div className="sidebar-stack-icon">
        <button type="button" onClick={() => setCollapsed(!collapsed)} aria-label="collapse-button">
          <Icon iconType="stack" color="currentColor" />
        </button>
      </div>
      <ul className="list-unstyled ps-0">
        <li className="mb-1">
          <SimpleOption link="/home" icon="home" isCollapsed={collapsed}>
            Home
          </SimpleOption>
          <SimpleOption link="/fileviewer" icon="archives" isCollapsed={collapsed}>
            Meus Arquivos
          </SimpleOption>
          <ExpandableOption link="/meteorology" label="Meteorologia" icon="meteorology" isCollapsed={collapsed} expandedOption={expandedOption} setExpandedOption={setExpandedOption}>
            <ExpandableOption.Option link="/meteorology/videos/categories">Vídeos</ExpandableOption.Option>
            <ExpandableOption.Option link="/meteorology/fields/observeddata">Mapas e Meteogramas</ExpandableOption.Option>
            <ExpandableOption.Option link="/meteorology/weather/oscillations/">Clima</ExpandableOption.Option>
            <ExpandableOption.Option link="/agro/register">Agrometeorologia</ExpandableOption.Option>
            <ExpandableOption.Option link="/meteorology/tutorial/categories">Tutorial</ExpandableOption.Option>
          </ExpandableOption>
          <ExpandableOption link="/flux" label="Flux" icon="flux" isCollapsed={collapsed} expandedOption={expandedOption} setExpandedOption={setExpandedOption}>
            <ExpandableOption.Option link="/flux/upload">Upload</ExpandableOption.Option>
            <ExpandableOption.Option link="/flux/personalized">Personalizado</ExpandableOption.Option>
            <ExpandableOption.Option link="/flux/automatic/classic">Automático</ExpandableOption.Option>
            <ExpandableOption.Option link="/flux/about">Sobre</ExpandableOption.Option>
            <ExpandableOption.Option link="/flux/videos/categories">Tutorial</ExpandableOption.Option>
          </ExpandableOption>
          {featureFlags.windx && (
            <ExpandableOption link="/windx" label="Windx" icon="wind" isCollapsed={collapsed} expandedOption={expandedOption} setExpandedOption={setExpandedOption}>
              <ExpandableOption.Option link="/windx/automatic">Automático</ExpandableOption.Option>
              <ExpandableOption.Option link="/windx/about">Sobre</ExpandableOption.Option>
            </ExpandableOption>
          )}
          {featureFlags.relatorios && (
            <ExpandableOption link="/relatorios" label="Relatórios" icon="line_axis" isCollapsed={collapsed} expandedOption={expandedOption} setExpandedOption={setExpandedOption}>
              <ExpandableOption.Option link="/relatorios/decomp">Informe Diário</ExpandableOption.Option>
              <ExpandableOption.Option link="/relatorios/intersemanal">Informe Intersemanal</ExpandableOption.Option>
              <ExpandableOption.Option link="/relatorios/semanal">Informe Semanal</ExpandableOption.Option>
              <ExpandableOption.Option link="/relatorios/mensal">Informe Mensal</ExpandableOption.Option>
            </ExpandableOption>
          )}
          {admin && (
            <ExpandableOption link="/admin" label="Administração" icon="admin" isCollapsed={collapsed} expandedOption={expandedOption} setExpandedOption={setExpandedOption}>
              <ExpandableOption.Option link="/admin/users">Usuários</ExpandableOption.Option>
              <ExpandableOption.Option link="/admin/companies">Empresas</ExpandableOption.Option>
              <ExpandableOption.Option link="/admin/financial">Financeiro</ExpandableOption.Option>
              <ExpandableOption.Option link="/admin/mailer/reports">Mailer</ExpandableOption.Option>
              <ExpandableOption.Option link="/admin/flux">Administração Flux</ExpandableOption.Option>
            </ExpandableOption>
          )}
        </li>
      </ul>

      <div className="flex-fill" />

      {!collapsed && (
        <div className="d-grid">
          <Button
            onClick={() => logout(navigate, { title: '', message: 'Logout realizado com sucesso.', variant: 'success' })}
            className="sidebar-logout-button ps-4"
          >
            Sair
          </Button>
        </div>
      )}

      <div className={`d-flex flex-row align-items-center mt-auto justify-content-${collapsed ? 'center' : 'between'}`}>
        {!collapsed && (
          <small className="version-number ms-2 mb-2">
            {versionString()}
          </small>
        )}
        <button
          type="button"
          aria-label="collapse-button"
          className={`btn-collapse m-2 ${collapsed ? 'collapsed' : ''}`}
          onClick={useClosure(setCollapsed, !collapsed)}
        >
          <Icon iconType={collapseIcon} color="currentColor" />
        </button>
      </div>
    </div>
  );
}
